// extracted by mini-css-extract-plugin
export var blue = "_40-g";
export var brand = "_40-c";
export var darkGrey = "_40-f";
export var disabled = "_40-6";
export var disabledSubtle = "_40-7";
export var error = "_40-8";
export var green = "_40-h";
export var grey = "_40-e";
export var icon = "_40-0";
export var inherit = "_40-b";
export var lightGrey = "_40-d";
export var orange = "_40-j";
export var pink = "_40-l";
export var primary = "_40-1";
export var purple = "_40-m";
export var quaternary = "_40-4";
export var quinary = "_40-5";
export var red = "_40-k";
export var secondary = "_40-2";
export var success = "_40-a";
export var tertiary = "_40-3";
export var warning = "_40-9";
export var white = "_40-n";
export var yellow = "_40-i";